import { render, staticRenderFns } from "./menuComponent.vue?vue&type=template&id=46ac4d73&"
import script from "./menuComponent.vue?vue&type=script&lang=js&"
export * from "./menuComponent.vue?vue&type=script&lang=js&"
import style0 from "./menuComponent.vue?vue&type=style&index=0&id=46ac4d73&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports